import React from 'react'
import { connect } from 'react-redux'
import PrecisionRound from '../../Utils/PrecisionRound'
import MarkupActions from '../../Redux/MarkupRedux'

class FormDelete extends React.Component {
  _delete = (event) => {
    event.preventDefault()
    const data = {
      id: this.props.detail.id
    }

    this.props.deleteMarkup(data)
    this.props.closeModal()
  }

  render () {
    const { detail } = this.props
    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Delete Markup?</h4>
        </div>
        <form onSubmit={(event) => this._delete(event)}>
          <div className='form-group text-center'>
            <h5>
              { detail.attraction && detail.attraction.title }
            </h5>
            <span className={`badge badge-${detail.value > 1 ? 'success' : (detail.value === 1 ? 'light' : 'danger')}`}>
              { detail.value > 1 && '+' }{ PrecisionRound((detail.value - 1) * 100) } %
            </span>
          </div>
          <div className='form-group text-right'>
            <button type='button' className='btn btn-secondary' onClick={() => this.props.closeModal()}>Cancel</button>
            <button type='submit' className='btn btn-danger ml-2'>Delete</button>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  deleteMarkup: (data) => dispatch(MarkupActions.markupDeleteRequest(data))
})

export default connect(stateToProps, dispatchToProps)(FormDelete)



// WEBPACK FOOTER //
// ./src/Containers/Markup/FormDelete.js